export default "__VITE_ASSET__CqwBWk4D__"